module.exports = __webpack_public_path__ + "media/packs/images/flags/RO-c68c68621679ae8258e0cff3c4ee5e8e.png";